<template>
    <div class="badge cursorPoint mt-1"
         :data-ga-element="`${gaData}tag|${badge}`"
         @click="goTagPage(badge)">
        {{ badge }}
    </div>
</template>
<script>
export default {
    name: 'Badge',
    props: {
        badge: {
            type: String,
            require: true,
        },
        contentPage: {
            type: String,
            require: true,
        },
    },
    computed: {
        gaData() {
            return (
                this.systemName +
                '|' +
                this.contentPage +
                '|'
            );
        },
    },
    methods: {
        goTagPage(tag) {
            this.closeAllBlock();
            this.$router.push({ name: 'tag', params: { page: 1, tag: tag } }).catch(() => { });
        },
        closeAllBlock() {
            this.$emit('closeAllBlock');
        }
    }
};
</script>
<style lang="scss" scoped>
.badge {
    max-width: 100%;
    border-radius: 3px;
    padding: 0.6rem;
    font-size: 15px;
    color: $gray-400;
    background-color: $gray-300;
    margin-right: 10px;
    font-weight: normal;
    position: relative;
    @extend %ellipsis-single;

    &:hover {
        color: $primary;
        background-color: $secondary;
    }
    @include media-breakpoint-up(lg) {
    }
}
</style>
